import TierGroup from "@/views/editor/service/promotion/tier_group";
import {INewBusiness} from "@/views/editor/service/business";
import Deposit from "@/views/editor/service/promotion/deposit";

export default {'tier_group': TierGroup, 'deposit': Deposit} as { [key: string]: INewBusiness }